<template>
  <modal-template :title="$t('insuranceModal.aseguraTuEntrada')"
                  @close="closeModal()">
    <div class="insurance-modal">
      <b-form @submit.prevent="manageData()">
        <p class="title-principal">{{ $t('insuranceModal.rellenaLosCamposConTusDatosPersonalesParaConfirmarElSeguroDeNoAsistencia') }}</p>
        <p class="title-separator">{{ $t('insuranceModal.datosDeLaPersonaQueContrataElSeguro') }}</p>
        <div class="container-inputs">
          <b-form-group>
            <b-form-input v-model="insuranceData.first_name"
                          v-validate="'required'"
                          type="text"
                          required
                          name="first_name"
                          :placeholder="$t('insuranceModal.nombre')"
                          :class="{'error': errors.has('first_name')}" />
          </b-form-group>
          <b-form-group>
            <b-form-input v-model="insuranceData.last_name"
                          v-validate="'required'"
                          type="text"
                          required
                          name="last_name"
                          :placeholder="$t('insuranceModal.apellido')"
                          :class="{'error': errors.has('last_name')}" />
          </b-form-group>
          <b-form-row>
            <b-col cols="9">
              <b-form-group>
                <b-form-input v-model="insuranceData.id_card"
                              v-validate="'required'"
                              type="text"
                              required
                              name="id_card"
                              :placeholder="$t('insuranceModal.id_card')"
                              :class="{'error': errors.has('id_card')}" />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group>
                <b-form-input v-model="insuranceData.id_card_letter"
                              v-validate="'required|min:1|max:1'"
                              type="text"
                              required
                              minlength="1"
                              maxlength="1"
                              name="id_card_letter"
                              :placeholder="$t('insuranceModal.letra')"
                              :class="{'error': errors.has('id_card_letter')}" />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-group>
            <b-form-input v-model="insuranceData.phone"
                          v-validate="'required|numeric|min:9'"
                          data-vv-as="field"
                          type="text"
                          required
                          name="phone"
                          minlength="9"
                          :placeholder="$t('insuranceModal.telefono')"
                          :class="{'error': errors.has('phone')}" />
          </b-form-group>
        </div>
        <div v-for="(ticket, index) in tickets"
             :key="index">
          <p class="title-separator">{{ ticket.title }}
            <span v-if="ticket.personal && ticket.name"> - {{ ticket.name }}</span>
          </p>
          <b-form-group :id="`is_owner-${index}Group`">
            <b-form-checkbox :id="`is_owner-${index}`"
                             v-model="insured[index].is_owner"
                             :disabled="!insuranceData.first_name || !insuranceData.last_name"
                             @input="sameInsured(index)">
              Es la misma persona que contrata el seguro
            </b-form-checkbox>
          </b-form-group>
          <div class="pLateral20">
            <b-form-group>
              <b-form-input v-model="insured[index].first_name"
                            v-validate="'required'"
                            type="text"
                            required
                            :name="`first_name[${index}]`"
                            :placeholder="$t('insuranceModal.nombre')"
                            :class="{'error': errors.has(`first_name[${index}]`)}" />
            </b-form-group>
            <b-form-group>
              <b-form-input v-model="insured[index].last_name"
                            v-validate="'required'"
                            type="text"
                            required
                            name="`last_name[${index}]`"
                            :placeholder="$t('insuranceModal.apellido')"
                            :class="{'error': errors.has(`last_name[${index}]`)}" />
            </b-form-group>
          </div>
        </div>
        <div class="mT20 mB20 tAc">
          <b-form-group id="general-conditions-group">
            <b-form-checkbox id="general-conditions"
                             v-model="insuranceData.general_conditions"
                             v-validate="'required'"
                             required>
              <span>Declaro que he leído, conozco y acepto las <a href="https://cdn.wegow.com/no-delete/caser/Condiciones-Generales-WEGOW.pdf"
                   target="_blank"
                   class="general-conditions-link">Condiciones Generales</a>
                y la
                <a href="https://cdn.wegow.com/no-delete/caser/Politica-de-privacidad-CASER-SEGUROS.pdf"
                   target="_blank"
                   class="general-conditions-link">Política de Privacidad de Caser</a>
              </span>
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="tAc">
          <button :disabled="errors.any() || !insuranceData.general_conditions"
                  :class="{'topaz': !errors.any() && insuranceData.general_conditions, 'transparent': errors.any() || !insuranceData.general_conditions}"
                  type="submit"
                  class="btn topaz">{{ $t('insuranceModal.añadirSeguro') }}</button>
        </div>
      </b-form>
    </div>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  props: {
    tickets: {
      type: Array,
      default: () => []
    },
    insuranceData: {
      type: Object,
      default: () => {}
    },
    addInsurance: {
      type: Function,
      default: () => ({})
    },
    thereIsInsurance: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      insured: []
    }
  },
  created() {
    this._createInsuranceData()
  },
  methods: {
    closeModal() {
      this.$emit('update:thereIsInsurance', false)
      this.$emit('update:insuranceData', {})
      this.$emit('closeInsuranceModal')
    },
    manageData() {
      this.addInsurance(this.insuranceData, this.insured)
      this.$emit('closeInsuranceModal')
    },
    sameInsured(index) {
      if (this.insured[index].is_owner) {
        this.$set(
          this.insured[index],
          'first_name',
          this.insuranceData.first_name
        )
        this.$set(
          this.insured[index],
          'last_name',
          this.insuranceData.last_name
        )
      } else {
        this.$set(this.insured[index], 'first_name', '')
        this.$set(this.insured[index], 'last_name', '')
      }
    },
    _createInsuranceData() {
      if (this.tickets) {
        this.tickets.forEach(ticket => {
          this.insured.push({
            ticket: ticket.id,
            is_owner: false,
            first_name: '',
            last_name: ''
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import './insurance-modal.sass';
</style>

